import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { Modal } from '@grandvisionhq/common';
import { useSetLoyaltyDetails, LoyaltyPointsCardForm, LoyaltyPointsOverviewCard } from '@grandvisionhq/fun-loyalty-points';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';

const EditableLoyaltyPointsSummary = ()=>{
    var ref;
    const { cart  } = Context.useCart();
    const [storedCart] = useCartStorage();
    const settings = useCheckoutSettings();
    const { getLabel  } = useIntl();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { setLoyaltyCardNumber  } = useSetLoyaltyDetails({
        onCompleted: ()=>setIsModalOpen(false)
    });
    const loyaltyLabels = {
        collected: getLabel('checkout.completed.loyaltyPoints.collected'),
        loyaltySymbol: getLabel('cart.loyalty.loyaltySymbol'),
        number: getLabel('cart.loyalty.saved.number'),
        heading: getLabel('checkout.overview.loyaltyPoints.heading'),
        edit: getLabel('common.actions.edit'),
        enterNumber: getLabel('cart.loyalty.title'),
        addCard: getLabel('cart.loyalty.addCard'),
        autoAdded: getLabel('cart.loyalty.autoAdded')
    };
    if (!cart || !cart.id || !settings.isPaybackCardNumberValid) {
        return null;
    }
    const loyaltyDetails = cart.loyaltyDetails;
    var ref1;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        title: getLabel('checkout.overview.loyaltyPoints.modalHeading'),
        showIcon: true
    }, /*#__PURE__*/ React.createElement(LoyaltyPointsCardForm, {
        onSubmit: (cardNumber)=>{
            setLoyaltyCardNumber(cardNumber, cart.id, storedCart.cartHash);
        },
        onClear: ()=>{
            setLoyaltyCardNumber(null, cart.id, storedCart.cartHash);
        },
        validateCardNumber: settings.isPaybackCardNumberValid,
        savedCardNumber: (ref1 = cart === null || cart === void 0 ? void 0 : (ref = cart.loyaltyDetails) === null || ref === void 0 ? void 0 : ref.cardNumber) !== null && ref1 !== void 0 ? ref1 : undefined
    })), loyaltyDetails && /*#__PURE__*/ React.createElement(LoyaltyPointsOverviewCard, {
        className: "checkout-card__reset-top-border-radius",
        onEdit: ()=>setIsModalOpen(true)
        ,
        onAdd: ()=>setIsModalOpen(true)
        ,
        labels: loyaltyLabels,
        loyaltyDetails: loyaltyDetails
    }));
};

export { EditableLoyaltyPointsSummary };
//# sourceMappingURL=EditableLoyaltyPointsSummary.js.map
